import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import { firestoreMethods } from '../../firebase/firestoreMethods';

import AdminHeader from '../AdminHeader';
import SubHeader from '../../SubHeader';
import SiteCard from './SiteCard';



function Sites() {

  const [ sites, setSites ] = useState();
  const [ refreshSites, setRefreshSites ] = useState(true);

  // fetch sites
  useEffect(() => {
    
    let active = true;
    const fetchSites = async () => {
      const newData = await firestoreMethods.getSites();
      if (active){
        setSites(newData);
        setRefreshSites(false);
      }
    };  

    if (refreshSites) {
      fetchSites();
    }
    
    return () => {
      active = false;
    };
  }, [refreshSites, setRefreshSites]);

  if (!sites) return null;
  
  return (
    <>
      <AdminHeader/>
      <SubHeader nav={-1} display="Sites"/> 
      <Link 
        to="new" 
        className='form-button primary'
      >Add Site
      </Link> 
      <div className='display-sites'>
        {sites.map((site) => 
          {
            return (
              <SiteCard key={site.id} site={site}/>
            )
          })
        }   
      </div>  
      <div>Things to check</div>
      <ul>
      <li>* paperless</li>
      <li></li>
      </ul>      
    </>
  );
}

export default Sites;
